(function () {
  'use strict';

  var requestInFlight = false;
  var lastCart = null;

  function positiveInt(value, fallback) {
    var number = parseInt(String(value == null ? '' : value).replace(/[^0-9]/g, ''), 10);
    return Number.isFinite(number) && number > 0 ? number : fallback;
  }

  function money(cents) {
    return 'R' + (Math.round(Number(cents || 0)) / 100)
      .toLocaleString('en-ZA', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
      .replace(/\s/g, '');
  }

  function plural(type, count) {
    return count === 1 ? type : (/s$/i.test(type) ? type : type + 's');
  }

  function cartItemFrom(element) {
    return element && element.closest('tr.cart-item, [id^="CartItem-"], [id^="CartDrawer-Item-"]');
  }

  function quantityInput(item) {
    return item && item.querySelector('input[name="updates[]"], input.quantity__input, quantity-input input');
  }

  function lineIndex(item) {
    var input = quantityInput(item);
    var index = positiveInt(input && input.dataset.index, 0);
    if (index) return index;

    index = positiveInt(item && (item.dataset.index || item.getAttribute('data-index')), 0);
    if (index) return index;

    var match = String(item && item.id || '').match(/(?:CartItem|CartDrawer-Item)-(\d+)/i);
    return match ? positiveInt(match[1], 0) : 0;
  }

  function packData(item) {
    var input = quantityInput(item);
    var pack = positiveInt(
      (item && (item.dataset.screwmanPackQty || item.getAttribute('data-screwman-pack-qty'))) ||
      (input && (input.dataset.screwmanPackQty || input.getAttribute('data-screwman-pack-qty'))),
      1
    );
    var type = (item && (item.dataset.screwmanPackType || item.getAttribute('data-screwman-pack-type'))) || 'Box';
    return { pack: Math.max(1, pack), type: type || 'Box' };
  }

  function normaliseQuantity(value, pack) {
    var qty = positiveInt(value, pack > 1 ? pack : 1);
    if (pack <= 1) return Math.max(1, qty);
    return Math.max(pack, Math.ceil(qty / pack) * pack);
  }

  function summaryElement(item) {
    var summaries = Array.from(item.querySelectorAll('.screwman-cart-box-summary'));
    var summary = summaries.shift();
    summaries.forEach(function (element) { element.remove(); });

    if (!summary) {
      summary = document.createElement('div');
      summary.className = 'screwman-cart-box-summary';
    }

    var details = item.querySelector('.cart-item__details');
    var unitPrice = details && details.querySelector('.cart-item__discounted-prices, .product-option');
    if (unitPrice && unitPrice.parentNode) {
      unitPrice.insertAdjacentElement('afterend', summary);
    } else if (details && !summary.isConnected) {
      details.appendChild(summary);
    }

    item.querySelectorAll('.cart-item__quantity .screwman-cart-box-summary, quantity-input .screwman-cart-box-summary')
      .forEach(function (element) { element.remove(); });

    return summary;
  }

  function updateSummary(item) {
    var input = quantityInput(item);
    if (!input) return;

    var data = packData(item);
    var qty = positiveInt(input.value, data.pack);
    var summary = summaryElement(item);

    if (data.pack > 1) {
      var packages = qty / data.pack;
      summary.textContent = qty + ' pieces = ' +
        (Number.isInteger(packages) ? packages : packages.toFixed(2).replace(/\.00$/, '')) + ' ' +
        plural(data.type, packages);
    } else {
      summary.textContent = 'Sold individually';
    }
  }

  function updateButtonStates(item) {
    var input = quantityInput(item);
    if (!input) return;

    var data = packData(item);
    var qty = positiveInt(input.value, data.pack);
    var minimum = data.pack > 1 ? data.pack : 1;
    var minus = item.querySelector('quantity-input .quantity__button[name="minus"]');
    if (minus) {
      minus.classList.toggle('disabled', qty <= minimum);
      minus.setAttribute('aria-disabled', qty <= minimum ? 'true' : 'false');
    }
  }

  function setLineError(item, message) {
    if (!item) return;
    var wrapper = item.querySelector('.cart-item__error');
    var text = item.querySelector('.cart-item__error-text');
    if (text) text.textContent = message || '';
    if (wrapper) wrapper.style.display = message ? '' : 'none';
  }

  function setBusy(busy, activeItem) {
    requestInFlight = !!busy;
    document.documentElement.classList.toggle('screwman-cart-request-active', !!busy);

    document.querySelectorAll('cart-items, cart-drawer-items').forEach(function (cart) {
      cart.classList.toggle('screwman-cart-controller-busy', !!busy);
    });

    document.querySelectorAll('cart-items quantity-input button, cart-items quantity-input input, cart-items cart-remove-button button, cart-items cart-remove-button a, cart-drawer-items quantity-input button, cart-drawer-items quantity-input input, cart-drawer-items cart-remove-button button, cart-drawer-items cart-remove-button a')
      .forEach(function (control) {
        if ('disabled' in control) control.disabled = !!busy;
        control.setAttribute('aria-busy', busy ? 'true' : 'false');
      });

    if (activeItem) activeItem.classList.toggle('screwman-cart-updating', !!busy);
  }

  function sectionDefinitions() {
    var definitions = [];
    var mainItems = document.getElementById('main-cart-items');
    var mainFooter = document.getElementById('main-cart-footer');

    if (mainItems && mainItems.dataset.id) {
      definitions.push({
        request: mainItems.dataset.id,
        target: '#main-cart-items .js-contents',
        source: '#main-cart-items .js-contents'
      });
    }

    if (mainFooter && mainFooter.dataset.id) {
      definitions.push({
        request: mainFooter.dataset.id,
        target: '#main-cart-footer .js-contents',
        source: '#main-cart-footer .js-contents'
      });
    }

    if (document.getElementById('CartDrawer')) {
      definitions.push({
        request: 'cart-drawer',
        target: '#CartDrawer .drawer__inner',
        source: '#CartDrawer .drawer__inner'
      });
    }

    if (document.getElementById('cart-icon-bubble')) {
      definitions.push({
        request: 'cart-icon-bubble',
        target: '#cart-icon-bubble',
        source: '#cart-icon-bubble',
        replaceOuter: true
      });
    }

    return definitions.filter(function (definition, index, all) {
      return all.findIndex(function (candidate) {
        return candidate.request === definition.request && candidate.target === definition.target;
      }) === index;
    });
  }

  function replaceSection(definition, html) {
    if (!html) return false;
    var documentFragment = new DOMParser().parseFromString(html, 'text/html');
    var source = documentFragment.querySelector(definition.source);
    var target = document.querySelector(definition.target);
    if (!source || !target) return false;

    if (definition.replaceOuter) {
      target.replaceWith(source);
    } else {
      target.innerHTML = source.innerHTML;
    }
    return true;
  }

  function renderCart(cart, definitions) {
    if (!cart || !cart.sections) return false;
    var replaced = 0;

    definitions.forEach(function (definition) {
      if (replaceSection(definition, cart.sections[definition.request])) replaced += 1;
    });

    document.querySelectorAll('.loading__spinner').forEach(function (spinner) {
      spinner.classList.add('hidden');
    });

    document.querySelectorAll('.totals__items').forEach(function (element) {
      element.textContent = cart.item_count;
      element.classList.toggle('hidden', cart.item_count > 1000);
    });

    document.querySelectorAll('cart-items, cart-drawer-items, cart-drawer, #main-cart-footer')
      .forEach(function (element) {
        element.classList.toggle('is-empty', cart.item_count === 0);
      });

    lastCart = cart;
    initialiseCartRows();
    updateFreeShipping(cart);
    document.dispatchEvent(new CustomEvent('screwman:cart-rendered', { detail: { cart: cart } }));
    return replaced > 0;
  }

  function readableError(data, fallback) {
    if (!data) return fallback;
    if (typeof data === 'string') return data;
    if (typeof data.description === 'string') return data.description;
    if (typeof data.message === 'string') return data.message;
    if (typeof data.errors === 'string') return data.errors;
    if (data.errors && typeof data.errors === 'object') {
      return Object.keys(data.errors).map(function (key) {
        var value = data.errors[key];
        return Array.isArray(value) ? value.join(', ') : String(value);
      }).join(' ');
    }
    return fallback;
  }

  function changeLine(item, requestedQuantity) {
    if (requestInFlight) return Promise.resolve(false);

    var line = lineIndex(item);
    if (!line) {
      setLineError(item, 'Could not identify this cart item. Please refresh the cart.');
      return Promise.resolve(false);
    }

    var definitions = sectionDefinitions();
    var requests = definitions.map(function (definition) { return definition.request; });
    var endpoint = (window.routes && window.routes.cart_change_url) || '/cart/change.js';

    setLineError(item, '');
    setBusy(true, item);

    return fetch(endpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        line: line,
        quantity: requestedQuantity,
        sections: requests,
        sections_url: window.location.pathname + window.location.search
      })
    })
      .then(function (response) {
        return response.json().catch(function () { return {}; }).then(function (data) {
          if (!response.ok || data.errors) {
            throw new Error(readableError(data, 'Could not update the cart.'));
          }
          return data;
        });
      })
      .then(function (cart) {
        var rendered = renderCart(cart, definitions);
        if (!rendered) {
          window.location.reload();
          return true;
        }
        return true;
      })
      .catch(function (error) {
        setLineError(item, error && error.message ? error.message : 'Could not update the cart.');
        return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
          .then(function (response) { return response.json(); })
          .then(function (cart) {
            lastCart = cart;
            var input = quantityInput(item);
            var actual = cart.items && cart.items[line - 1] ? cart.items[line - 1].quantity : null;
            if (input && actual != null) input.value = actual;
            updateSummary(item);
            updateButtonStates(item);
            updateFreeShipping(cart);
            return false;
          })
          .catch(function () { return false; });
      })
      .finally(function () {
        setBusy(false, item);
        document.querySelectorAll('.loading__spinner').forEach(function (spinner) {
          spinner.classList.add('hidden');
        });
      });
  }

  function updateFreeShipping(cart) {
    if (!cart) return;
    var threshold = parseInt(window.SCREWMAN_FREE_SHIPPING_THRESHOLD_CENTS || 100000, 10);
    var remaining = Math.max(0, threshold - Number(cart.total_price || 0));
    var percentage = Math.max(0, Math.min(100, (Number(cart.total_price || 0) / threshold) * 100));
    var text = remaining > 0 ? 'Spend ' + money(remaining) + ' more for free shipping.' : 'You qualify for free shipping.';
    var banner = document.querySelector('.screwman-cart-small-free-shipping');

    if (!banner) {
      banner = document.createElement('div');
      banner.className = 'screwman-cart-small-free-shipping';
      banner.innerHTML = '<strong></strong><div><span></span></div>';
    }

    var label = banner.querySelector('strong');
    var bar = banner.querySelector('span');
    if (label) label.textContent = text;
    if (bar) bar.style.width = percentage + '%';

    var totals = document.querySelector('.cart__footer .totals, .cart-drawer__footer .totals, .cart__blocks .totals, .totals');
    if (totals && totals.parentNode && banner.parentNode !== totals.parentNode) {
      totals.parentNode.insertBefore(banner, totals);
    } else if (totals && totals.previousElementSibling !== banner) {
      totals.parentNode.insertBefore(banner, totals);
    }

    document.querySelectorAll('.screwman-shipping-estimate, .screwman-free-shipping-progress')
      .forEach(function (element) { element.remove(); });
  }

  function fetchCartSummary() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        lastCart = cart;
        updateFreeShipping(cart);
        return cart;
      })
      .catch(function () { return null; });
  }

  function initialiseCartRows() {
    document.querySelectorAll('tr.cart-item, [id^="CartItem-"], [id^="CartDrawer-Item-"]').forEach(function (item) {
      var input = quantityInput(item);
      if (!input) return;

      var data = packData(item);
      input.setAttribute('inputmode', 'numeric');
      input.min = String(data.pack > 1 ? data.pack : 1);
      input.step = String(data.pack > 1 ? data.pack : 1);
      input.dataset.min = input.min;
      input.removeAttribute('max');
      input.removeAttribute('data-max');

      updateSummary(item);
      updateButtonStates(item);
    });
  }

  function housekeeping() {
    document.querySelectorAll('a[href="/collections/all"], a[href*="/collections/all"]')
      .forEach(function (link) { link.href = '/collections/fasteners'; });

    document.querySelectorAll('body *').forEach(function (element) {
      if (element.children.length) return;
      if (/\bZAR\b/i.test(element.textContent || '')) {
        element.textContent = element.textContent.replace(/\s*ZAR\s*/gi, '');
      }
      if ((element.textContent || '').indexOf('Free shipping on all orders above $50') !== -1) {
        element.style.display = 'none';
      }
    });
  }

  document.addEventListener('click', function (event) {
    var quantityButton = event.target.closest('cart-items quantity-input .quantity__button, cart-drawer-items quantity-input .quantity__button');
    if (quantityButton) {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      if (requestInFlight || quantityButton.disabled) return;
      var item = cartItemFrom(quantityButton);
      var input = quantityInput(item);
      if (!item || !input) return;

      var data = packData(item);
      var current = normaliseQuantity(input.value, data.pack);
      var target = quantityButton.name === 'plus'
        ? current + data.pack
        : Math.max(data.pack > 1 ? data.pack : 1, current - data.pack);

      if (target === current) {
        updateButtonStates(item);
        return;
      }

      input.value = target;
      updateSummary(item);
      updateButtonStates(item);
      changeLine(item, target);
      return;
    }

    var removeControl = event.target.closest('cart-items [data-screwman-cart-remove], cart-drawer-items [data-screwman-cart-remove], cart-items cart-remove-button, cart-drawer-items cart-remove-button, .cart-item__remove-btn, .cart-remove-button');
    if (removeControl) {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      if (requestInFlight) return;
      var removeItem = cartItemFrom(removeControl);
      if (!removeItem) return;
      changeLine(removeItem, 0);
    }
  }, true);

  document.addEventListener('change', function (event) {
    var input = event.target.closest('cart-items input[name="updates[]"], cart-drawer-items input[name="updates[]"]');
    if (!input) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    if (requestInFlight) return;
    var item = cartItemFrom(input);
    if (!item) return;

    var data = packData(item);
    var target = normaliseQuantity(input.value, data.pack);
    input.value = target;
    updateSummary(item);
    updateButtonStates(item);
    changeLine(item, target);
  }, true);

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter') return;
    var input = event.target.closest('cart-items input[name="updates[]"], cart-drawer-items input[name="updates[]"]');
    if (!input) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    if (requestInFlight) return;
    var item = cartItemFrom(input);
    if (!item) return;

    var data = packData(item);
    var target = normaliseQuantity(input.value, data.pack);
    input.value = target;
    updateSummary(item);
    updateButtonStates(item);
    changeLine(item, target);
  }, true);

  document.addEventListener('input', function (event) {
    var input = event.target.closest('cart-items input[name="updates[]"], cart-drawer-items input[name="updates[]"]');
    if (!input) return;
    var item = cartItemFrom(input);
    if (!item) return;
    updateSummary(item);
  }, true);

  function init() {
    initialiseCartRows();
    housekeeping();
    fetchCartSummary();
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
  if (document.readyState !== 'loading') init();
})();
